var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { NotificationsService } from "../../../services/notifications/notifications-service";
import { NotificationEntryTypeEnum } from "../../../models/notifications/notifications.models";
import { ArrayUtils } from "../../../utilities/arrays";
import { autoinject, transient } from "aurelia-dependency-injection";
import { computedFrom } from "aurelia-binding";
import { NotificationCenterEntryComposer } from "./notification-center-entry-composer";
import { PropertyChangeNotifier } from "../../../models/basics/basics.models";
import { NotificationType, NotificationClientService } from "../../../services/basics/notification-client.service";
import { EnumUtilities } from "../../../utilities/enum-utilities";
import moment from "moment";
var NotificationCenter = /** @class */ (function () {
    function NotificationCenter(alertNotificationssService, notificationsService, notificationCenterEntryComposer) {
        var _this = this;
        this.alertNotificationssService = alertNotificationssService;
        this.notificationsService = notificationsService;
        this.notificationCenterEntryComposer = notificationCenterEntryComposer;
        this._searchText = '';
        this.isPanelOpened = false;
        this.filterOpened = false;
        this.refresher = new PropertyChangeNotifier();
        this.notificationModels = [];
        this.tabs = [{
                show: true,
                view: null,
                title: function () { return "<span class=\"text\">Alerts</span>\n                      <span class=\"badge\">".concat(_this.alertsUnseenCounter || '', "</span>"); },
                step: 1,
                onClick: function () {
                    if (_this.notificationsFiltered) {
                        var notificationsSeensNow = _this.notificationsFiltered.filter(function (x) { return !x.hasBeenSeen; });
                        notificationsSeensNow.forEach(function (notification) {
                            notification.hasBeenSeen = true;
                            notification.seenFirstTime = true;
                        });
                        _this.alertNotificationssService.markNotificationsAsSeen(notificationsSeensNow.map(function (x) { return x.notificationId; }));
                        if (_this.tabsVM) {
                            _this.tabsVM.titleKeyChanged();
                        }
                        _this.refresher.trigger();
                    }
                }
            }, {
                show: true,
                view: null,
                title: function () { return "<span class=\"text\">Notifications</span>\n                      <span class=\"badge\">".concat(_this.notificationsUnseenCounter || '', "</span>"); },
                step: 2,
                onClick: function () {
                    if (_this.notificationModels) {
                        _this.notificationModels.filter(function (x) { return !x.hasBeenSeen; }).forEach(function (x) {
                            x.hasBeenSeen = true;
                            x.seenFirstTime = true;
                        });
                        if (_this.tabsVM) {
                            _this.tabsVM.titleKeyChanged();
                        }
                        _this.refresher.trigger();
                    }
                }
            }];
        this.onNotificationPushed = function (x) {
            _this.notificationModels.unshift(x);
            if (_this.tabsVM) {
                _this.tabsVM.titleKeyChanged();
            }
            _this.refresher.trigger();
        };
        this.togglePanel = function (event) {
            if (!event || !event["propagationStopped"]) {
                _this.preventDefault(event);
                _this.isPanelOpened = !_this.isPanelOpened;
                if (_this.isPanelOpened) {
                    document.addEventListener('click', _this.togglePanel, false);
                }
                else {
                    document.removeEventListener('click', _this.togglePanel, false);
                }
                if (_this.isPanelOpened) {
                    if (_this.currentTab.step == 2) {
                        _this.notificationModels.filter(function (x) { return x.hasBeenSeen; }).forEach(function (x) {
                            x.seenFirstTime = false;
                        });
                        _this.notificationModels.filter(function (x) { return !x.hasBeenSeen; }).forEach(function (x) {
                            x.hasBeenSeen = true;
                            x.seenFirstTime = true;
                        });
                    }
                    else {
                        _this.notificationsFiltered.filter(function (x) { return x.hasBeenSeen; }).forEach(function (x) {
                            x.seenFirstTime = false;
                        });
                        var notificationsSeensNow = _this.notificationsFiltered.filter(function (x) { return !x.hasBeenSeen; });
                        notificationsSeensNow.forEach(function (notification) {
                            notification.hasBeenSeen = true;
                            notification.seenFirstTime = true;
                        });
                        _this.alertNotificationssService.markNotificationsAsSeen(notificationsSeensNow.map(function (x) { return x.notificationId; }));
                    }
                    if (_this.tabsVM) {
                        _this.tabsVM.titleKeyChanged();
                    }
                    _this.refresher.trigger();
                }
            }
        };
        this.notificationsService.subscribeShow(this.onNotificationPushed);
    }
    Object.defineProperty(NotificationCenter.prototype, "searchText", {
        get: function () {
            return this._searchText;
        },
        set: function (value) {
            this._searchText = value;
            this.filterNotifications();
        },
        enumerable: false,
        configurable: true
    });
    NotificationCenter.prototype.attached = function () {
        var _this = this;
        this.alertNotificationssService.register(this);
        var types = Object.keys(NotificationEntryTypeEnum);
        types.forEach(function (key) {
            var value = NotificationEntryTypeEnum[key];
            _this.notificationCenterEntryComposer.register({ type: value, viewModel: './notifications/classic-notification' }, false);
        });
        this.alertNotificationssService.fetchNotificationsNotDismissed().then(function (response) {
            _this.notifications = response.notifications;
            _this.filterNotifications();
        });
    };
    Object.defineProperty(NotificationCenter.prototype, "alertsUnseenCounter", {
        get: function () {
            return this.notificationsFiltered ? this.notificationsFiltered.filter(function (x) { return !x.hasBeenSeen; }).length : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationCenter.prototype, "notificationsUnseenCounter", {
        get: function () {
            return this.notificationModels ? this.notificationModels.filter(function (x) { return !x.hasBeenSeen; }).length : 0;
        },
        enumerable: false,
        configurable: true
    });
    NotificationCenter.prototype.preventDefault = function (event) {
        if (event) {
            event.stopPropagation();
        }
    };
    NotificationCenter.prototype.pushedNotification = function (notification) {
        var index = ArrayUtils.findIndex(this.notifications, function (x) { return x.notificationId == notification.notificationId; });
        if (index < 0) {
            this.notifications.unshift(notification);
        }
        else {
            this.notifications.splice(index, 1, notification);
        }
        if (this.isPanelOpened && this.notificationsFiltered.some(function (z) { return z.notificationId == notification.notificationId; })) {
            notification.hasBeenSeen = true;
            notification.seenFirstTime = true;
            this.alertNotificationssService.markNotificationsAsSeen([notification.notificationId]);
        }
        this.filterNotifications();
    };
    NotificationCenter.prototype.deletedNotification = function (notification) {
        var index = ArrayUtils.findIndex(this.notifications, function (x) { return x.notificationId == notification.notificationId; });
        if (index > -1) {
            this.notifications.splice(index, 1);
            this.filterNotifications();
        }
    };
    NotificationCenter.prototype.getTime = function (date) {
        var dateConverted = new Date(date);
        return moment(dateConverted).format("MMMM Do YYYY HH:mm");
    };
    NotificationCenter.prototype.toggleFilter = function () {
        this.filterOpened = !this.filterOpened;
        event.stopPropagation();
    };
    NotificationCenter.prototype.filterNotifications = function () {
        var _this = this;
        this.notificationsFiltered = this.searchText ? this.notifications.filter(function (x) {
            return x.message.indexOf(_this.searchText) > -1 ||
                x.title.indexOf(_this.searchText) > -1 ||
                _this.getTime(x.dateCreated).indexOf(_this.searchText) > -1;
        }) : this.notifications.slice(0);
    };
    NotificationCenter.prototype.dismiss = function ($event, notification) {
        if (notification.notificationId > 0) {
            this.alertNotificationssService.dismissNotification(notification.notificationId);
        }
        var index = ArrayUtils.findIndex(this.notifications, function (x) { return x.notificationId == notification.notificationId; });
        if (index > -1) {
            this.notifications.splice(index, 1);
        }
        this.filterNotifications();
        this.preventDefault($event);
    };
    NotificationCenter.prototype.removeNotification = function (notificationModel) {
        var _this = this;
        var index = this.notificationModels.indexOf(notificationModel);
        notificationModel.isHidden = true;
        if (index == -1) {
            return;
        }
        setTimeout(function () {
            _this.notificationModels.splice(index, 1);
        }, 300);
    };
    NotificationCenter.prototype.getEnumName = function (type) {
        var name = EnumUtilities.getName(NotificationType, type);
        return name ? name.toLowerCase() : "";
    };
    __decorate([
        computedFrom('_searchText'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], NotificationCenter.prototype, "searchText", null);
    __decorate([
        computedFrom('notificationsFiltered', 'refresher.state'),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], NotificationCenter.prototype, "alertsUnseenCounter", null);
    __decorate([
        computedFrom('notificationModels', 'refresher.state'),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], NotificationCenter.prototype, "notificationsUnseenCounter", null);
    NotificationCenter = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationsService,
            NotificationClientService,
            NotificationCenterEntryComposer])
    ], NotificationCenter);
    return NotificationCenter;
}());
export { NotificationCenter };
